import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBELcuCI0dI1jZ3YgjQcAEiWV33mRTUdaY",
  authDomain: "eza-crm.firebaseapp.com",
  databaseURL: "https://eza-crm-default-rtdb.firebaseio.com",
  projectId: "eza-crm",
  storageBucket: "eza-crm.appspot.com",
  messagingSenderId: "396360091379",
  appId: "1:396360091379:web:56c68a7b514f4cfa5d9986",
  measurementId: "G-VHCGMW0JL7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
